module.exports = __webpack_public_path__ + "img/petrorio.7fb2836b.png";